import { useState } from 'react';
import * as Icons from 'lucide-react';
import { ChevronDown } from 'lucide-react';
import { PIPELINE } from '../../config/site';
import { SectionHeader } from '../common';

export default function IntelligencePipeline() {
  const [open, setOpen] = useState(0);
  return (
    <section className="section">
      <div className="container-x">
        <div className="reveal"><SectionHeader center eyebrow="Intelligence Pipeline" title="From market noise to trade intelligence." sub="Seven disciplined stages transform raw data into a structured, risk-aware trade decision." /></div>
        <div className="max-w-[820px] mx-auto mt-14 flex flex-col gap-3">
          {PIPELINE.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Circle;
            const active = open === i;
            return (
              <div key={p.title} className="panel expand-row reveal" style={{ transitionDelay: `${i * 40}ms`, borderColor: active ? 'var(--gold-border)' : 'var(--border)' }} onClick={() => setOpen(active ? -1 : i)}>
                <div className="flex items-center gap-4 p-5">
                  <span className="font-mono text-[12px] text-[var(--muted-2)] w-6">{String(i + 1).padStart(2, '0')}</span>
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0" style={{ background: active ? 'var(--gold-soft)' : 'var(--surface-2)', border: `1px solid ${active ? 'var(--gold-border)' : 'var(--border)'}` }}><Icon size={18} style={{ color: active ? 'var(--gold-2)' : 'var(--muted)' }} /></div>
                  <span className="font-display text-[16px] font-bold text-white flex-1">{p.title}</span>
                  <ChevronDown size={18} className="text-[var(--muted-2)] transition-transform duration-300" style={{ transform: active ? 'rotate(180deg)' : 'none' }} />
                </div>
                <div className="overflow-hidden transition-all duration-300" style={{ maxHeight: active ? 200 : 0 }}>
                  <p className="px-5 pb-5 pl-[74px] text-[14.5px] text-[var(--muted)] leading-relaxed">{p.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
